import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

export interface EpisodeOfCareResponse {
  motherEncounter: fhirTypes.Encounter;
  episodeOfCareResources: {
    childEncounter: fhirTypes.Encounter;
    episodeOfCare: fhirTypes.EpisodeOfCare;
    condition: fhirTypes.Condition;
  }[];
}

// TODO(Jaffe): Fix this. Needs a select: to transform the fhir resources into objects.
// Right now everyone is constructing their own objects.
export const useEpisodesOfCare = (encounterId?: string, enabled = true) => {
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApi<EpisodeOfCareResponse>({
    queryOptions: {
      enabled: Boolean(encounterId) && enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<EpisodeOfCareResponse>(
          "/charting/encounter-charting/resources",
          {
            params: {
              motherEncounterId: encounterId,
            },
          },
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.DEFAULT({
        patientId,
        encounterId,
      }),
    },
  });
};
